const placeholderRegex = /{{\s*(\w+)\s*}}/;
const thousandsRegex = /(\d)(?=(\d\d\d)+(?!\d))/g;

function formatWithDelimiters(
    number: number,
    precision: number = 2,
    thousands: string = ",",
    decimal: string = "."
): string {
    const parts = (number / 100.0).toFixed(precision).split(".");
    const dollars = parts[0].replace(thousandsRegex, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
}

function formatMoney(cents: number | string, formatString: string) {
    const centsNumber = typeof cents == "string" ? parseInt(cents.replace(".", "")) : cents;
    let value = "";

    switch (formatString.match(placeholderRegex)?.[1]) {
        case "amount":
            value = formatWithDelimiters(centsNumber, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(centsNumber, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(centsNumber, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(centsNumber, 0, ".", ",");
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

interface NumberFormatOptions {
    style: string;
    currency?: string;
    currencyDisplay?: string;
    roundingMode?: string;
    maximumFractionDigits?: number;
    minimumFractionDigits?: number;
}

export class MoneyFormatter {
    private options: NumberFormatOptions;
    private withSymbol: boolean = true;

    constructor() {
        this.options = {
            style: "currency",
            currency: Shopify.currency.active,
            currencyDisplay: "symbol"
        };
    }

    public noDecimals() {
        this.options.maximumFractionDigits = 0;
        this.options.minimumFractionDigits = 0;
        return this;
    }

    public stripSymbol() {
        this.options.currencyDisplay = "code";
        this.withSymbol = false;
        return this;
    }

    public format(cents: number) {
        const result = new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, this.options).format(cents / 100);

        return this.withSymbol
            ? result
            : result
                  .replace(/[a-z]+/i, "")
                  .trim()
                  .replace(/\s/g, " ");
    }
}

function formatMoneyIntl(cents: number) {
    return new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
        style: "currency",
        currency: Shopify.currency.active,
        currencyDisplay: "symbol"
    }).format(cents / 100);
}

export { formatMoney, formatMoneyIntl };
